/*
 * Part of Yaru.one Service
 * Copyright (c) 2017. Christian Archer
 * Copyright (c) 2017. Shaula Software
 * All rights reserved
 */

"use strict";

function yaruReCaptchaCallback() {
    $('.g-recaptcha').each((index, element) => {
        grecaptcha.render(element, { sitekey: element.dataset.sitekey });
    });
}
